import { Box } from '@mui/system';
import React, { memo } from 'react';

function DeleteDocument() {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <h2>The document that you are trying to view is deleted</h2>
    </Box>
  );
}

export default memo(DeleteDocument);
